module.exports = __webpack_public_path__ + "img/66.90fd5308.png";